const DeniedRedIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_3163_4853)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00002 2.00033C4.68631 2.00033 2.00002 4.68662 2.00002 8.00033C2.00002 11.314 4.68631 14.0003 8.00002 14.0003C11.3137 14.0003 14 11.314 14 8.00033C14 4.68662 11.3137 2.00033 8.00002 2.00033ZM0.666687 8.00033C0.666687 3.95024 3.94993 0.666992 8.00002 0.666992C12.0501 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0501 15.3337 8.00002 15.3337C3.94993 15.3337 0.666687 12.0504 0.666687 8.00033Z"
          fill="#942020"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4714 5.52827C10.7317 5.78862 10.7317 6.21073 10.4714 6.47108L6.47138 10.4711C6.21103 10.7314 5.78892 10.7314 5.52858 10.4711C5.26823 10.2107 5.26823 9.78862 5.52858 9.52827L9.52858 5.52827C9.78892 5.26792 10.211 5.26792 10.4714 5.52827Z"
          fill="#942020"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.52858 5.52827C5.78892 5.26792 6.21103 5.26792 6.47138 5.52827L10.4714 9.52827C10.7317 9.78862 10.7317 10.2107 10.4714 10.4711C10.211 10.7314 9.78892 10.7314 9.52858 10.4711L5.52858 6.47108C5.26823 6.21073 5.26823 5.78862 5.52858 5.52827Z"
          fill="#942020"
        />
      </g>
      <defs>
        <clipPath id="clip0_3163_4853">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeniedRedIcon;
